<template lang="html">
  <div class="share" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/backShare.png` +')'}">
    <div class="informerBtn" @click="informerShow = 1">
      <p>一键举报</p>
    </div>
    
    <!-- 轮播 -->
    <div class="shareCard" :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/card.png` +')'}">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <PosterWithQRCode :imgUrl="`http://app.eda365.com:8088/pages/m/static/img/assistance/poster2.png`" :QRCodeMsg="shareUrl" />
          </div>
          <div class="swiper-slide">
            <PosterWithQRCode :imgUrl="`http://app.eda365.com:8088/pages/m/static/img/assistance/poster3.png`" :QRCodeMsg="shareUrl" />
          </div>
          <div class="swiper-slide">
            <PosterWithQRCode :imgUrl="`http://app.eda365.com:8088/pages/m/static/img/assistance/poster1.png`" :QRCodeMsg="shareUrl" />
          </div>
        </div>
      </div>

      <div class="downPoster">
        <img :src="`${pagebase}/static/img/assistance/icon3.png`" alt="">
        <p>长按海报下载到相册</p>
      </div>

      <div class="downText">
        <div class="downTextTitle">
          <p>单击下方文本复制</p>
          <img :src="`${pagebase}/static/img/assistance/icon2.png`" alt="">
        </div>

        <div class="change" @click="getChange">
          <img :src="`${pagebase}/static/img/assistance/icon4.png`" alt="">
          <p>换一换</p>
        </div>
      </div>

      <div class="randomTxt" v-show="cur == 1" @click="copeText($event)">
        <p :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/txt.png` +')'}">
          电子人都在免费领的2023年日历，新的一年，赢在起跑线！还有超大办公桌垫、超千份半导体、硬件学习资料……对我太有用了，扫码帮我解锁一下
        </p>
      </div>
      <div class="randomTxt" v-show="cur == 2" @click="copeText($event)">
        <p :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/txt.png` +')'}">
          我正在包邮免费领半导体产业链图谱桌垫，拥有能铺满桌面的超大尺寸，还能随时查询产业链上下游信息~帮我扫码解锁，你也可以领取~
        </p>
      </div>
      <div class="randomTxt" v-show="cur == 3" @click="copeText($event)">
        <p :style="{backgroundImage: 'url('+ `${pagebase}/static/img/assistance/txt.png` +')'}">
          6000+电子工程师已免费领取的2023计划日历、超大半导体/PCB桌垫，我正在领取，帮我扫码解锁，你也可以免费领取！
        </p>
      </div>

      <div class="shareMod">
        <div @click="shareHintShow = 1">
          <img :src="`${pagebase}/static/img/assistance/wx.png`" alt="">
          <p>微信好友</p>
        </div>
        <p class="xian"></p>
        <div @click="shareHintShow = 1">
          <img :src="`${pagebase}/static/img/assistance/friend.png`" alt="">
          <p>朋友圈</p>
        </div>
      </div>
    </div>
    
    <div class="informerHint" v-show="informerShow == 1" @click.self="informerShow = 0">
      <div class="informerCon">
        <p class="informerInfo">已收到您的反馈，客服会尽快<br>与您取得联系</p>
        <p class="informerClose" @click="informerShow = 0">我知道了</p>
      </div>
    </div>

    <div class="shareHint" v-show="shareHintShow == 1" @click="shareHintShow = 0">
      <img :src="`${pagebase}/static/img/assistance/share.png`" alt="">
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/utils.js';
  import Swiper from 'swiper/swiper-bundle.min.js'
  import 'swiper/swiper-bundle.min.css'
  import {
    pagebase
  } from '@/utils/http.js';
  import WxShare from '@/utils/wxshare'
  import Cookies from 'js-cookie';
  import PosterWithQRCode from '@/components/PosterWithQRCode'

  export default {
    data() {
      return {
        pagebase: pagebase,
        imageUrl: require("@/assets/image/DClogo.png"),
        cur: 1,
        informerShow: 0,
        shareHintShow: 0,
        shareUrl: '',
      }
    },

    components: {
      PosterWithQRCode,
    },

    mounted() {
      this.init();
      this.getShowStat(0);
    },

    methods: {
      getShowStat(id){
        // var channel = this.$route.query.channel || '';
        // var activityId = this.$route.query.activityId || '';
        this.$http.get('/api/showStat', {
          params: {
            url: window.location.href,
            type: id,
          }
        })
      },
      
      init() {
        this.getSwiper();
        new WxShare().share({
          title: '快来和我一起免费领半导体/PCB行业桌垫~',
          desc: '和HW工程师解封绝密技术资料！',
          link: 'http://app.eda365.com:8088/pages/m/#/assistance?aid=' + Cookies.get('aid') + '&activityId=' + this.$route.query.activityId,
          imgUrl: pagebase + '/static/img/assistance/breviaryImg.png'
        });
        
        this.shareUrl = 'http://app.eda365.com:8088/pages/m/#/assistance?aid=' + Cookies.get('aid') + '&activityId=' + this.$route.query.activityId;
      },
      
      copeText(e) {
        const input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', e.target.textContent)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
        }
        document.body.removeChild(input)
        utils.showMessage('文本内容已复制')
      },

      getSwiper() {
        new Swiper(".swiper", {
          centeredSlides: true,
          spaceBetween: -10,
        });
      },

      getChange() {
        this.cur = Math.floor(Math.random() * (3 - 0)) + 1;
      },
    }
  }
</script>

<style lang="css" scoped>
  .share {
    height: 81.2rem;
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-size: 100% 100%;
    padding-top: 1.35rem;
    padding-bottom: 2.75rem;
  }
  
  .informerBtn {
    display: flex;
    justify-content: flex-end;
  }
  
  .informerBtn p {
    width: 8rem;
    height: 2.5rem;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    color: #F22D0A;
    margin-right: -1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2.5rem 0 0 2.5rem;
  }

  .shareCard {
    box-sizing: border-box;
    background-size: 100% 100%;
    height: 69.3rem;
    margin-top: 1rem;
    padding-top: 2rem;
    border-radius: 1rem;
  }

  .swiper {
    box-sizing: border-box;
    padding: 0 5rem;
    height: 40rem;
    border-radius: 1rem;

    overflow: hidden;
  }

  .swiper-wrapper {
    width: 100%;
  }

  .swiper-slide {
    width: 25rem;
    height: 40rem;
    transform: scale(0.8);
  }

  .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  
  .posterWrapper img {
    width: 100%;
    height: 100%;
  }

  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1);
  }

  .downPoster {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    font-size: 1.3rem;
    color: #333333;
  }

  .downPoster img {
    width: 1.35rem;
    height: 1.35rem;
    margin-right: .2rem;
  }

  .downText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.05rem;
    margin-top: 1.55rem;
  }

  .downTextTitle {
    display: flex;
    align-items: center;
    font-size: 1.35rem;
    color: #333333;
    font-weight: 600;
  }

  .downTextTitle img {
    height: .8rem;
    margin-left: .5rem;
  }

  .change {
    width: 6rem;
    display: flex;
    font-size: 1.3rem;
    color: #FF5A0D;
  }

  .change img {
    height: 1.5rem;
  }

  .randomTxt {
    margin-top: .5rem;
    box-sizing: border-box;
    padding: 0 1rem;
  }
  
  .randomTxt p {
    box-sizing: border-box;
    height: 9.6rem;
    padding: 1rem;
    line-height: 2.5rem;
    background-size: 100% 100%;
    font-size: 1.3rem;
    color: #444444;
  }

  .shareMod {
    margin-top: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    color: #333333;
  }

  .xian {
    width: .05rem;
    height: 2.5rem;
    background-color: #FBAB8D;
    margin: 0 6rem;
  }

  .shareMod div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .shareMod img {
    width: 4.3rem;
  }
  
  /* 举报 */
  .informerHint {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .informerCon {
    width: 30rem;
    height: 19.3rem;
    background-color: #FFFFFF;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  
  .informerInfo {
    font-size: 1.6rem;
    color: #1D2023;
  }
  
  .informerClose {
    width: 22.6rem;
    height: 4.4rem;
    background: linear-gradient(170deg, #FFCC76, #FF9A4D);
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4.4rem;
    color: #642207;
    font-size: 1.8rem;
    font-weight: 600;
  }

  /* 分享 */
  .shareHint {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 10;
    padding: 0 4.4rem;
  }
  
  .shareHint img {
    margin-top: 2rem;
    width: 100%;
  }
</style>
